import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InMemoryCacheService, UtilsService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardService  {

  public constructor(
    private readonly router: Router,
    private readonly cache: InMemoryCacheService,
    private readonly utils: UtilsService
  ) {}

  public async canActivate(): Promise<boolean> {
    const token = this.utils.parseJwt(this.cache?.auth?.token);
    const rawRoles: unknown = token?.staff_role;
    const roles = Array.isArray(rawRoles)
      ? rawRoles.map(role => String(role).toLowerCase())
      : typeof rawRoles === 'string'
        ? rawRoles.split(',').map(role => role.trim().toLowerCase())
        : [];
    const hasAdminPanelAccess = roles.some(role =>
      role === 'superuser'
      || role === 'insightgaineradministrator'
      || role === 'customerservice'
    );

    if (!hasAdminPanelAccess) {
      this.router.navigate(['/notfound']);
    }
    return hasAdminPanelAccess;
  }

}
